import { makeStyles } from '@mui/styles';

export default makeStyles(theme => ({
    menuIconWrapper: {
        transform: 'rotate(90deg)',
        marginLeft: 2,
        '&:disabled $menuIcon': {
            opacity: 0.4
        }
    },
    menuIcon: {
        color: '#A9AAAE'
    },
    tooltipLink: {
        fontWeight: 'bold',
        color: theme.palette.primary.main
    },
    copyLinkButton: {
        '&:disabled': {
            opacity: 0.4
        }
    }
}));
